import camelCase from 'lodash/fp/camelCase';
import mapKeys from 'lodash/fp/mapKeys';

export const keysToCamelCase = mapKeys(camelCase);

// TODO TYPING
export default function camelizeNestedKeys(object: any):
  | {
      [key: string]: string;
    }
  | any {
  if (Array.isArray(object)) {
    return object.map((v) => camelizeNestedKeys(v));
  }
  if (Object.prototype.toString.call(object) === '[object Object]') {
    // if (object !== null && Object(object) === object) {
    return Object.keys(object).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: camelizeNestedKeys(object[key])
      }),
      {}
    );
  }
  return object;
}
